// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__gJHgp","checkbox":"Checkbox_checkbox__pWMMi","checkbox_checked":"Checkbox_checkbox_checked__+oMsK"};